export default __webpack_public_path__ + "static/media/connect-with-providers.7260eb8d.png";